import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
Vue.use(Router)

const routerMap = [
  {
    path: '/',
    redirect: '/main',
  },
  {
    path: '/live',
    name: 'Live',
    meta: { title: '直播demo' },
    component: () =>
      import(/* webpackChunkName: "live" */ '@/views/live/index.vue'),
  },
  {
    path: '/main',
    name: 'Main',
    meta: { title: '车险报价', keepAlive: true },
    component: () =>
      import(/* webpackChunkName: "main" */ '@/views/main/index.vue'),
  },
  {
    path: '/carInfo',
    name: 'CarInfo',
    meta: { title: '车险报价', keepAlive: true },
    component: () =>
      import(/* webpackChunkName: "carInfo" */ '@/views/carInfo/index.vue'),
  },
  {
    // 车险报价列表页
    path: '/quotationList',
    name: 'QuotationList',
    meta: { title: '车险报价', keepAlive: true },
    component: () =>
      import(/* webpackChunkName: "q_list" */ '@/views/quotation/list.vue'),
  },
  {
    // 车险报价详情页
    path: '/quotationDetail',
    name: 'QuotationDetail',
    meta: { title: '车险报价' },
    component: () =>
      import(/* webpackChunkName: "q_detail" */ '@/views/quotation/detail.vue'),
  },
  {
    // 投保信息补充
    path: '/personInfo',
    name: 'PersonInfo',
    meta: { title: '车险报价', keepAlive: true },
    component: () =>
      import(
        /* webpackChunkName: "personInfo" */ '@/views/personInfo/index.vue'
      ),
  },
  {
    // 我的报价单
    path: '/orderList',
    name: 'OrderList',
    meta: { title: '我的报价单', keepAlive: true },
    component: () =>
      import(/* webpackChunkName: "orderList" */ '@/views/orderList/index.vue'),
  },
  {
    path: '/result',
    name: 'Result',
    meta: { title: '车险报价' },
    component: () =>
      import(/* webpackChunkName: "result" */ '@/views/result/index.vue'),
  },
  {
    path: '/success',
    name: 'Success',
    meta: { title: '车险报价' },
    component: () =>
      import(/* webpackChunkName: "success" */ '@/views/success/index.vue'),
  },
  {
    path: '/detail',
    name: 'Detail',
    meta: { title: '车险报价' },
    component: () =>
      import(/* webpackChunkName: "detail" */ '@/views/detail/index.vue'),
  },
  {
    path: '/pay',
    name: 'Pay',
    meta: { title: '车险报价' },
    component: () =>
      import(/* webpackChunkName: "Pay" */ '@/views/pay/index.vue'),
  },
  {
    path: '/online',
    name: 'Online',
    meta: { title: '人工客服' },
    component: () =>
      import(/* webpackChunkName: "Pay" */ '@/views/online/index.vue'),
  },
]
const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: routerMap,
})
let replaceFlag = false
let replaceCache = router.replace.bind(router)
router.replace = function () {
  replaceFlag = true
  replaceCache(...arguments)
}
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.afterEach((to, from) => {
  console.log(to)
  navFn(to)
  replaceFlag = false
})

let navFn = function (to) {
  if (replaceFlag) {
    store.commit('nav/replace', to.name)
  } else {
    let routes = store.state.nav.routes
    console.log('routes', routes)
    let toIndex = routes.lastIndexOf(to.name)
    if (toIndex === -1) {
      store.commit('nav/forward', to.name)
    } else if (toIndex === routes.length - 1) {
      sessionStorage.h5_vue_nav = ''
      // window.location.href = '/main'
    } else {
      let count = routes.length - 1 - toIndex
      store.commit('nav/back', count)
    }
  }
}
export default router
